import {
  GET_RECOLECCIONES_CANCELADAS_START,
  GET_RECOLECCIONES_CANCELADAS_SUCCESS,
  GET_RECOLECCIONES_CANCELADAS_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: [],
  error: null
}

const  canceladas = (state = initialState, { type, payload, error }) => {

  switch(type) {

    case GET_RECOLECCIONES_CANCELADAS_START:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_RECOLECCIONES_CANCELADAS_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case GET_RECOLECCIONES_CANCELADAS_ERROR:
      return {
        ...state,
        loading: false,
        error
      }
    
    default : return state

  }

}

export default canceladas